import React from "react";
import { cn } from "../../../../lib/utils";
import GlassOptionsRadioGroup from "./GlassOptionsRadioGroup";

const GlassOptions = ({ methods, isOpen: { GlassOptions } }) => {
    return (
        <div
            className={cn(
                "section grid grid-cols-4 overflow-hidden transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: GlassOptions.isOpen,
                }
            )}
        >
            <GlassOptionsRadioGroup {...methods} />
        </div>
    );
};

export default GlassOptions;

